export default __webpack_public_path__ + "static/media/car-loader.6f7b540f.svg";